module.exports = __webpack_public_path__ + "img/047ec55.jpg";